import { useMemo } from 'react'
import { Select } from 'peach/components'
import { useInternalUsersGet } from 'core/types'
import { useCompanyInfo } from 'core/stores/bootstrap'
import { getName } from 'peach/helpers'
import _ from 'lodash'

const CompanyAgentUserSelect = (props) => {
  const company = useCompanyInfo()
  const companyId = props.companyId || company.id

  const { data: users = [], isLoading } = useInternalUsersGet({
    companyId,
    query: { limit: 100, userType: 'agent' },
  })

  const options = useMemo(() => {
    return _.map(users, (user) => ({ value: user.id, label: getName(user) }))
  }, [users])

  return (
    <Select
      options={options}
      loading={isLoading}
      disabled={isLoading || !companyId}
      {...props}
    />
  )
}

export default CompanyAgentUserSelect
